export default {
  computed: {
    visualizationPinColor() {
      let color;

      if (this.isVisualizationPinSearched || this.isVisualizationPinSelected) {
        // NOTE: 検索後
        color = '#ea5514';
      } else {
        // NOTE: 検索前
        color = '#f39800';
      };

      return color;
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/map_pin.js